"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AFFILIATE_HALFYEARLY_LOOKUP_KEYS = exports.AFFILIATE_YEARLY_LOOKUP_KEYS = exports.AFFILIATE_MONTHLY_LOOKUP_KEYS = void 0;
var lookup_key_enum_1 = require("../enums/lookup-key-enum");
exports.AFFILIATE_MONTHLY_LOOKUP_KEYS = [
    lookup_key_enum_1.LookupKeyEnum.PremiumMonthlyEur,
    lookup_key_enum_1.LookupKeyEnum.PremiumMonthlyCzk,
    lookup_key_enum_1.LookupKeyEnum.PremiumMonthlyCzk202411,
    lookup_key_enum_1.LookupKeyEnum.PremiumMonthlyCzk202605,
];
exports.AFFILIATE_YEARLY_LOOKUP_KEYS = [
    lookup_key_enum_1.LookupKeyEnum.PremiumYearly,
    lookup_key_enum_1.LookupKeyEnum.PremiumYearlyCzk,
    lookup_key_enum_1.LookupKeyEnum.PremiumYearlyCzk202411,
];
exports.AFFILIATE_HALFYEARLY_LOOKUP_KEYS = [lookup_key_enum_1.LookupKeyEnum.PremiumHalfYearlyCzk202605];
//# sourceMappingURL=affiliate-subscription-lookup-keys.js.map